import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import api from 'api';
import ListingContext from '../../../../../../providers/Listing/Listing.context';
import DocumentLockedIcon from 'icons/DocumentLocked.icon';
import { sentryError, dateFormat } from 'utils';
import TrashIcon from 'icons/Trash.icon';
import { Button } from 'ncoded-component-library';
import AddCustomNdaModal from '../AddCustomNdaModal';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './NdaUploaded.styles.scss';

type NdaUploadedProps = {
  className?: string;
};

const NdaUploaded: React.FC<NdaUploadedProps> = (props) => {
  const { className } = props;

  const { isSuperAdmin } = useContext(CurrentUserContext);
  const { areActionsDisabled, listing, setListing } =
    useContext(ListingContext);

  const {
    _id: listingId,
    envelopeTemplateName,
    envelopeTemplateUploaded,
  } = listing || {};

  const [chooseDocsModal, chooseDocsModalRef] = useCallbackRef();

  const { t } = useTranslation();

  const deleteNDA = useCallback(async () => {
    try {
      const { data } = await api.portfolio.seller.deleteEnvelopeTemplate(
        listingId,
      );
      setListing(data);
    } catch (error) {
      sentryError(error);
    }
  }, [listingId, setListing]);

  const classes = classNames('nda-uploaded', className);

  return (
    <div className={classes}>
      <div className="nda-uploaded__file">
        <DocumentLockedIcon />
        <div>
          <p>{envelopeTemplateName || t('nonDisclosureAgreement')}</p>
          <p>
            {t('uploaded')} {dateFormat(envelopeTemplateUploaded)}
          </p>
        </div>
        {isSuperAdmin && (
          <Button variant="icon" icon={TrashIcon} onClick={deleteNDA} />
        )}
      </div>
      <Button
        variant="link"
        disabled={areActionsDisabled}
        {...(!areActionsDisabled && { onClick: chooseDocsModal?.open })}
      >
        {t('chooseDocsToUnlockAfterNDA')}
      </Button>

      <AddCustomNdaModal ref={chooseDocsModalRef} />
    </div>
  );
};

export default NdaUploaded;
